// extracted by mini-css-extract-plugin
export default {"popupContainer":"iGmmaCNqAobNTllJzxgJ","popup":"OOhlRWeVcnWXHPfzFgdQ","agreement":"jvPwgHvLAtlyk3OnQM_C","button":"nqhi0A1AjXvVulZAXAMk"};